import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";

const features = [
    {
        title: "Flexible UI Customization",
        description: "Tailor the user interface to your organization’s needs, creating personalized experiences for every user.",
        imgUrl: "./img/services/customization/flex-ui.jpg",
    },
    {
        title: "Custom Entities and Fields",
        description: "Create custom entities and fields to store the data relevant to your business and ensure streamlined workflows.",
        imgUrl: "./img/services/customization/custom-entities-and-fields.jpg",
    },
    {
        title: "Business Rules and Logic",
        description: "Set business rules to automate processes, validate data, and ensure consistency across all operations.",
        imgUrl: "./img/services/customization/business-rules.jpg",
    },
    {
        title: "Custom Workflows and Automations",
        description: "Design and implement custom workflows and automation to improve productivity and reduce manual intervention.",
        imgUrl: "./img/services/customization/custom-wf.png",
    },
    {
        title: "Power Apps Integration",
        description: "Integrate with Power Apps to create low-code applications and extend functionality without the need for extensive coding.",
        imgUrl: "./img/services/customization/pa-integration.png",
    },
    {
        title: "Third-Party Integration",
        description: "Integrate with third-party applications, CRMs, or legacy systems to ensure seamless data flow and connectivity.",
        imgUrl: "./img/services/customization/third-party-integration.png",
    },
];

const Customizations = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "Customizations", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="Customizations in Dynamics 365" description="Enhance your Dynamics 365 solution with powerful customizations that align with your business processes and objectives." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What Are Customizations in Dynamics 365?</h2>
                            <p>
                                Customization in Dynamics 365 refers to the ability to modify the platform to better suit your organization's unique needs. From customizing the user interface (UI) to creating new entities and automating processes, Dynamics 365 offers extensive tools to tailor the system to your business processes. These customizations help you enhance efficiency, improve user experience, and integrate with other applications seamlessly.
                            </p>
                            <img
                                src="./img/services/customization.jpg"
                                alt="Dynamics 365 Customizations"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Key Customization Features</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of Customizing Dynamics 365</h2>
                            <ul>
                                <li>
                                    <strong>Tailored User Experience:</strong> Customize the user interface to match your organization's workflows and improve user adoption.
                                </li>
                                <li>
                                    <strong>Improved Efficiency:</strong> Automate business processes, set rules, and integrate third-party tools to streamline operations.
                                </li>
                                <li>
                                    <strong>Enhanced Data Management:</strong> Create custom entities and fields to organize and manage data according to your business requirements.
                                </li>
                                <li>
                                    <strong>Seamless Integration:</strong> Easily integrate with third-party applications, ensuring that your Dynamics 365 system communicates smoothly with other platforms.
                                </li>
                                <li>
                                    <strong>Scalable Solutions:</strong> As your business grows, your customizations can evolve, ensuring the solution continues to meet your needs.
                                </li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Customize Your Dynamics 365 Experience</h2>
                            <p>
                                Make Dynamics 365 work for your business with powerful customizations. <br />
                                Reach out to us at{" "}
                                <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default Customizations;
